import {Attendee} from 'Event/attendee'
import {
  DEFAULT_BUTTON_BACKGROUND_COLOR,
  DEFAULT_BUTTON_TEXT_COLOR,
} from 'lib/ui/Button/CustomButton'
import {BOLD, CAPS, ITALIC} from 'lib/ui/typography/FontStyleInput'
import {ButtonStyles, Widget} from 'Event/Widget/template'
import {loadGoogleFont} from 'Event/Widget/script/helpers/fonts'
import {redirectOnClick} from 'Event/Widget/script/helpers/url'

export function renderButton(
  container: HTMLElement,
  widget: Widget,
  loginUrl: Attendee['login_url'],
) {
  const buttonStyles = widget.template.button.styles

  loadGoogleFont(
    `https://fonts.googleapis.com/css2?family=${font(
      buttonStyles,
    )}&display=swap`,
  )

  //reset container
  container.innerHTML = ''
  container.style.width = '100%'
  container.style.display = 'flex'
  container.style.justifyContent = 'center'
  container.style.alignItems = 'center'

  const button = document.createElement('button')

  // Configurable styles
  button.style.border = border(buttonStyles)
  button.style.background =
    buttonStyles?.backgroundColor || DEFAULT_BUTTON_BACKGROUND_COLOR
  button.style.borderRadius = buttonStyles?.borderRadius + 'px' || '0px'
  button.style.fontSize = buttonStyles?.fontSize + 'px' || ''
  button.style.minHeight = buttonStyles?.height + 'px' || 'auto'
  button.style.maxWidth = buttonStyles?.width + 'px' || 'auto'
  button.style.color = buttonStyles?.textColor || DEFAULT_BUTTON_TEXT_COLOR
  button.style.fontWeight = buttonStyles.font?.styles?.includes(BOLD)
    ? 'bold'
    : 'normal'
  button.style.fontStyle = buttonStyles.font?.styles?.includes(ITALIC)
    ? 'italic'
    : 'normal'
  button.style.textTransform = buttonStyles.font?.styles?.includes(CAPS)
    ? 'uppercase'
    : 'none'
  button.style.fontFamily = font(buttonStyles)
  // Default styles
  button.style.cursor = 'pointer'
  button.style.display = 'flex'
  button.style.alignItems = 'center'
  button.style.justifyContent = 'center'
  button.style.backgroundPosition = 'center'
  button.style.backgroundSize = 'cover'
  button.style.position = 'relative'
  button.style.height = 'auto'
  button.style.padding = '5px'
  button.style.lineHeight = '1.15'
  button.style.minWidth = 'min-content'

  button.style.transition = 'opacity 0.2s ease-in-out'

  button.addEventListener('mouseenter', () => {
    button.style.background =
      buttonStyles?.hoverBackgroundColor || DEFAULT_BUTTON_BACKGROUND_COLOR
    button.style.borderColor =
      buttonStyles?.hoverBorderColor || button.style.borderColor
    button.style.color = buttonStyles?.hoverTextColor || button.style.color
  })

  button.addEventListener('mouseleave', () => {
    button.style.background =
      buttonStyles?.backgroundColor || DEFAULT_BUTTON_BACKGROUND_COLOR
    button.style.borderColor =
      buttonStyles?.borderColor || button.style.borderColor
    button.style.color = buttonStyles?.textColor || button.style.color
  })

  container.appendChild(button)

  const text = document.createElement('div')

  text.style.display = 'flex'
  text.style.flexDirection = 'row'

  text.innerText = widget.template.button.label || ''
  button.appendChild(text)

  button.onclick = () => {
    redirectOnClick(loginUrl)
  }
}

function border(buttonStyles: ButtonStyles) {
  if (!buttonStyles.borderWidth) {
    return 'none'
  }

  return `${buttonStyles.borderWidth}px solid ${
    buttonStyles.borderColor || '#000000'
  }`
}

function font(buttonStyles: ButtonStyles) {
  if (!buttonStyles?.font?.family) {
    return 'Rubik'
  }

  if (buttonStyles.font.family === 'inherit') {
    return 'Rubik'
  }

  return buttonStyles.font.family
}
